import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutGrid, LogOut, User, Mailbox } from "lucide-react";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-blue-700 text-white flex items-center justify-center font-bold text-xs tracking-tight">DHD</div>
          <div className="flex flex-col leading-tight">
            <span className="font-semibold text-slate-900 tracking-tight">Domain Host Directory</span>
            <span className="text-[10px] uppercase tracking-widest text-slate-500">Trusted businesses</span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-700">
          <Link to="/directory" data-testid="nav-directory" className="hover:text-blue-700 transition-colors">Directory</Link>
          <Link to="/directory?type=professional" data-testid="nav-professionals" className="hover:text-blue-700 transition-colors">Professionals</Link>
          <Link to="/directory?featured=1" data-testid="nav-featured" className="hover:text-blue-700 transition-colors">Featured</Link>
        </nav>

        <div className="flex items-center gap-2">
          {user && typeof user === "object" ? (
            <>
              {(user.role === "business_owner" || user.role === "admin") && (
                <Button asChild variant="ghost" size="sm" data-testid="nav-dashboard">
                  <Link to="/dashboard"><LayoutGrid className="h-4 w-4 mr-1" /> Dashboard</Link>
                </Button>
              )}
              {(user.role === "admin" || user.role === "mail_clerk") && (
                <Button asChild variant="ghost" size="sm" data-testid="nav-mail">
                  <Link to="/mail"><Mailbox className="h-4 w-4 mr-1" /> Mail</Link>
                </Button>
              )}
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-100 text-slate-700 text-xs">
                <User className="h-3.5 w-3.5" />
                <span data-testid="nav-user-name">{user.name}</span>
              </div>
              <Button size="sm" variant="outline" onClick={onLogout} data-testid="nav-logout">
                <LogOut className="h-4 w-4 mr-1" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button asChild variant="ghost" size="sm" data-testid="nav-login">
                <Link to="/login">Log in</Link>
              </Button>
              <Button asChild size="sm" className="bg-blue-700 hover:bg-blue-800 text-white" data-testid="nav-register">
                <Link to="/register">Get Listed</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
